import {
  Fun,
  none,
  Option,
  some
} from 'widgets-for-react';
import * as React from 'react'

export type IframeProps = {
  url: string
  onLoaded: Fun<void, void>
}

type IframeState = {
  height: number
  width: string
  status: 'loading' | 'done'
}

type Size = {
  width: number,
  height: number
}

const parseIframeSizerMessage = (m: string): Option<Size> => {
  const [ label, heightStr, widthStr, event ] = m.split(':')

  if (label !== '[iFrameSizer]') return none()

  const height = parseInt(heightStr)
  const width = parseInt(widthStr)

  if (height == NaN || width == NaN) return none()

  return some<Size>({height, width})
}

export class Iframe extends React.Component<IframeProps, IframeState> {
  private iframe: React.RefObject<HTMLIFrameElement> | null = null

  constructor(props: IframeProps) {
    super(props)

    this.iframe = React.createRef()

    this.state = {
      width: '100%',
      height: 400,
      status: 'loading'
    }

    this.handleIFrameLoad = this.handleIFrameLoad.bind(this)
    this.handlePostMessage = this.handlePostMessage.bind(this)
  }

  componentDidMount() {
    window.addEventListener('message', this.handlePostMessage)
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handlePostMessage)
  }

  handleIFrameLoad() {
    if (this.iframe) {
      this.setState(s => ({ ...s, status: 'done'}))
      this.iframe.current.contentWindow.postMessage('[iFrameSizer]:init:true', '*')
    }
  }

  handlePostMessage(m: MessageEvent) {
    if (typeof m.data !== 'string') return

    const iframeSize = parseIframeSizerMessage(m.data)
    iframeSize.v.kind === 'r' && this.setState({ height: iframeSize.v.v.height })
  }

  render() {
    return (
      <>
        {this.state.status === 'loading' && (
          <p className="iframe-loading">Content is loading...</p>
        )}
        <iframe
          className="iframe"
          src={this.props.url}
          onLoad={this.handleIFrameLoad}
          ref={this.iframe}
          {...this.state}>
        </iframe>
      </>
    )
  }
}
